var poll_default = {
  "fontElementMap": "JbHDy",
  "container": "gePvQ",
  "fullscreen": "ON34k",
  "background_overlay": "QzigP",
  "with_image": "LKGAM",
  "options": "FcyBJ",
  "webview": "MfNgg",
  "grid": "zDnL7",
  "option": "_803Yu",
  "cta_button": "-TeyS",
  "add_option": "_172xN",
  "see_more": "CWZdE",
  "list": "_2AQrW",
  "column": "Hae1u",
  "additional_note": "hyyZs",
  "spinner": "_3ngZC",
  "spin": "vVvZj",
  "shown": "g3JJn",
  "error": "J-IIn"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
